import { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import Sidebar from "../global/Sidebar";
import { FiltersContext } from "../store/filters-options-context";
import HeaderFixed from "./indicator/FixedHeader";
import RepositoryListDataTable from "./RepositoryListDataTable";
import NoData from "./ErrorMessage";
import Footer from "./Footer";
import LoadProgress from "../global/Loading";


export default function RepositoryFilesList(props) {
    const { valueSelected, setMainCategory } = useContext(FiltersContext);
    const [filteredLinks, setFilteredLinks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    let { type, section, fileCategoryId, countryId } = useParams();
    const firstAreaValue = countryId;


    useEffect(() => {
        if (countryId && section) {
            const repositoryURL = `https://europe-west2-fao-maps-review.cloudfunctions.net/fao-cca-archive-read?country=${countryId}`;

            setIsLoading(true);

            fetch(repositoryURL)
                .then((response) => response.json())
                .then((data) => {
                    const filtered = data?.usefulLinks.filter(
                        (link) => link.categoryId === Number(fileCategoryId)
                    );
                    setFilteredLinks(filtered);
                })
                .catch((error) => {
                    console.error("Error fetching useful links:", error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [countryId, section, fileCategoryId])


    useEffect(() => {
        setMainCategory(type)
    }, []);



    return (
        <Box display="flex" flexDirection="row" className="container">
            <Sidebar section={section} area={firstAreaValue} />
            <Box
                display="flex"
                flexDirection="column"
                className="right-column"
            >
                <HeaderFixed country={valueSelected.area} />
                <Box
                    id="scroll-content"
                    sx={{
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundColor: "secondary.main",
                    }}
                >
                    <Box className="single-item">
                        <Box
                            display="flex"
                            alignItems="baseline"
                            justifyContent="space-between"
                        >
                            <Typography
                                variant="h2"
                                sx={{
                                    alignItems: { xs: "top", md: "center" },
                                    textTransform: "capitalize",
                                }}
                            >
                                {section}
                            </Typography>
                            {/* <Button
                variant="outlined"
                size="large"
                startIcon={<AddCircleOutlinedIcon />}
              >
                Add file
              </Button> */}
                        </Box>
                        <Box
                            sx={{
                                borderRadius: "3px",
                                width: "100%",
                            }}
                        >
                            {isLoading ? (
                                <LoadProgress isFetching={isLoading} />
                            ) : filteredLinks.length > 0 ? (
                                <RepositoryListDataTable data={filteredLinks} />
                            ) : (
                                <NoData text="No files or links available for this country." severity='warning' />
                            )}
                        </Box>
                    </Box>
                    <Footer />
                </Box>
            </Box>
        </Box>
    );
}

